module.exports = __webpack_public_path__ + "img/userM.2c1a1ec7.svg";